<template>
  <div class="home">
    <Header />
    <section class="container in-container">
      <div class="row">
        <div class="col-lg-7">
          <img src="static/Appscreen.png" alt="appscreen" srcset="" />
        </div>
        <div class="col-lg-5 download-area">
          <h1 class="title">Vconsol for Court</h1>
          <p class="sub-title">
            Connect & collaborate with your team members face-to-face with HD
            quality audio & video on the go with Vconsol Business.
          </p>
          <div class="download-btn">
            <!-- android -->
            <b-button
              v-if="isAndroid"
              class="play-badge"
              variant="link"
              block
              @click.prevent="playStore"
            >
              <img
                class="img-fluid"
                src="static/play-badge.svg"
                alt=""
                srcset=""
              />
            </b-button>
            <!-- ios -->
            <b-button
              v-if="isIos"
              class="ios-badge"
              variant="link"
              block
              @click.prevent="appStore"
            >
              <img
                class="img-fluid"
                src="static/ios-badge.svg"
                alt=""
                srcset=""
              />
            </b-button>
            <!-- windows -->
            <b-button
              v-if="isWindows"
              title="windows"
              variant="primary"
              @click.prevent="download(source['win64-exe'])"
            >
              <span>Download for Windows</span>
              <span class="ico"><win-ico /></span>
              <span class="down"><down-ico /></span>
            </b-button>
            <!-- linux -->
            <b-button
              v-if="isLinux"
              variant="primary"
              @click.prevent="download(source['linux64-deb'])"
            >
              <span>Download for Linux(.deb)</span>
              <span class="ico"><lin-ico /></span>
              <span class="down"><down-ico /></span>
            </b-button>
            <b-button
              v-if="isLinux"
              variant="primary"
              class="ml-4"
              @click.prevent="download(source['linux64-rpm'])"
            >
              <span>Download for Linux(.rpm)</span>
              <span class="ico"><lin-ico /></span>
              <span class="down"><down-ico /></span>
            </b-button>
            <!-- mac -->
            <b-button
              v-if="isMac"
              variant="primary"
              @click.prevent="download(source['osx64-dmg'])"
            >
              <span>Download for Mac(.dmg)</span>
              <span class="ico"><mac-ico /></span>
              <span class="down"><down-ico /></span>
            </b-button>
            <!-- <b-button
          v-if="isMac"
          variant="primary"
          class="ml-4"
          @click.prevent="download(source['osx64-pkg'])"
        >
          <span>Download for Mac(.pkg)</span>
          <span class="ico"><mac-ico /></span>
          <span class="down"><down-ico /></span>
        </b-button> -->
          </div>
          <!-- <p>Download the latest version for Windows</p> -->
          <b-link
            v-if="isDesktop"
            class="toggle-others"
            @click.prevent="toggleOthers = !toggleOthers"
          >
            Looking for a different OS?
          </b-link>
          <!-- <div class="preview">
        <img
          class="img-fluid"
          src="@/assets/meeting-page.png"
          alt=""
          srcset=""
        />
      </div> -->
        </div>
        <div class="col-12">
          <div v-if="toggleOthers" class="other-downloads">
            <div v-if="!isLinux" class="items">
              <h5 class="os-title">Linux</h5>
              <p>file size: {{ this.getSize(source["linux64-deb"]) }}</p>
              <b-button
                variant="primary"
                @click.prevent="download(source['linux64-deb'])"
              >
                <span class="ico"><lin-ico /></span>
                <span>Download for Linux(.deb)</span>
              </b-button>

              <p class="mt-3">
                file size: {{ this.getSize(source["linux64-rpm"]) }}
              </p>
              <b-button
                variant="primary"
                @click.prevent="download(source['linux64-rpm'])"
              >
                <span class="ico"><lin-ico /></span>
                <span>Download for Linux(.rpm)</span>
              </b-button>
            </div>

            <div v-if="!isMac" class="items">
              <h5 class="os-title">Mac</h5>
              <p>file size: {{ this.getSize(source["osx64-dmg"]) }}</p>
              <b-button
                variant="primary"
                @click.prevent="download(source['osx64-dmg'])"
              >
                <span class="ico mac"><mac-ico /></span>
                <span>Download for Mac(.dmg)</span>
              </b-button>

              <!-- <p class="mt-3">file size: {{ this.getSize(source["osx64-pkg"]) }}</p>
          <b-button
            variant="primary"
            @click.prevent="download(source['osx64-pkg'])"
          >
            <span class="ico mac"><mac-ico /></span>
            <span>Download for Mac(.pkg)</span>
          </b-button> -->
            </div>

            <div v-if="!isWindows" class="items">
              <h5 class="os-title">Windows</h5>
              <p>file size: {{ this.getSize(source["win64-exe"]) }}</p>
              <b-button
                variant="primary"
                @click.prevent="download(source['win64-exe'])"
              >
                <span class="ico mac"><win-ico /></span>
                <span>Download for Windows</span>
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="mobile-preview-section">
      <div class="container">
        <div class="mobile-preview">
          <div class="align-center">
            <h1>Available in Play store and App store</h1>
            <div class="d-flex justify-content-center">
              <b-button
                class="play-badge"
                variant="link"
                block
                @click.prevent="playStore"
              >
                <img
                  class="img-fluid"
                  src="static/play-badge.svg"
                  alt=""
                  srcset=""
                />
              </b-button>
              <!-- ios -->
              <b-button
                class="ios-badge"
                variant="link"
                block
                @click.prevent="appStore"
              >
                <img
                  class="img-fluid"
                  src="static/ios-badge.svg"
                  alt=""
                  srcset=""
                />
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- <p class="ml-auto mb-0 fixed-popup">
      Vconsol is currently available only to a limited circle of Govt. of India
      officials. It will be available to the public soon.
    </p> -->
    <Footer />
  </div>
</template>

<script>
const axios = require("axios");

import Header from "@/components/header.vue";
import Footer from "@/components/Footer.vue";
import WinIco from "@/components/svg/win.vue";
import LinIco from "@/components/svg/lin.vue";
import MacIco from "@/components/svg/mac.vue";
import DownIco from "@/components/svg/down.vue";

export default {
  name: "Home",
  components: {
    Header,
    Footer,
    WinIco,
    LinIco,
    MacIco,
    DownIco,
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL || "/",
      source: {},
      isDesktop: true,
      isWindows: false,
      isLinux: false,
      isMac: false,
      isAndroid: false,
      isIos: false,
      toggleOthers: false,
    };
  },
  created() {
    this.getSources();
    this.getOS();
    console.log("device.windows() === %s", this.getOS());
  },
  methods: {
    getOS() {
      var userAgent = window.navigator.userAgent,
        platform = window.navigator.platform,
        macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
        windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
        iosPlatforms = ["iPhone", "iPad", "iPod"],
        os = null;

      if (macosPlatforms.indexOf(platform) !== -1) {
        os = "Mac OS";
        this.isMac = true;
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = "iOS";
        this.isIos = true;
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = "Windows";
        this.isWindows = true;
      } else if (/Android/.test(userAgent)) {
        os = "Android";
        this.isDesktop = false;
        this.isAndroid = true;
      } else if (!os && /Linux/.test(platform)) {
        os = "Linux";
        this.isLinux = true;
      }

      return os;
    },

    // not using
    forceFileDownload(response, item) {
      var headers = response.headers;
      var extension = item.url.substring(item.url.lastIndexOf(".") + 1);
      var blob = new Blob([response.data], { type: headers["content-type"] });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${item.name}.${extension}`;
      link.click();
      link.remove();
    },

    // not using
    downloadAxios(item) {
      axios({
        method: "get",
        url: item.url,
        responseType: "blob",
      })
        .then((response) => {
          this.forceFileDownload(response, item);
        })
        .catch(() => console.log("error occured"));
    },

    download(item) {
      var extension = item.url.substring(item.url.lastIndexOf(".") + 1);
      var link = document.createElement("a");
      link.href = item.url;
      link.download = `${item.name}.${extension}`; // this customization not guarentted see: https://stackoverflow.com/questions/23872902/chrome-download-attribute-not-working
      link.click();
      link.remove();
    },

    // Mobile
    playStore() {
      window.location = this.source["android-playstore"].url;
    },

    appStore() {
      console.log("hs", this.source["ios-appstore"].url);
      window.location = this.source["ios-appstore"].url;
    },

    getSources() {
      axios
        .get(`${this.baseUrl}constants/sources.json`, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          try {
            if (typeof response.data === "string") {
              response.data = JSON.parse(response.data);
            }
            this.source = response.data;
          } catch (error) {
            console.log("Error: Failed to read download sources", error);
          }
        });
    },

    getSize(source) {
      if (source && source.size) {
        return source.size;
      }
      return "Unknown";
    },
  },
};
</script>
